// extracted by mini-css-extract-plugin
export default {"header":"FilterHeader_header__9DkUH","searchContainer__textfield":"FilterHeader_searchContainer__textfield__u8VgB"};